import { Directive, ElementRef, HostListener, Input, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appTrimSpaces]'
})
export class TrimSpacesDirective {
    @Input()
    appTrimSpaces?: boolean;

    constructor(
        private readonly elementRef: ElementRef,
        @Optional() private readonly ngControl: NgControl | null = null
    ) {}

    @HostListener('blur')
    onBlur() {
        if (this.appTrimSpaces) {
            const inputValue = this.elementRef.nativeElement.value;
            const trimmedValue = inputValue.trim().replace(/\s+/g, ' ');

            this.elementRef.nativeElement.value = trimmedValue;

            if (this.ngControl?.control) {
                this.ngControl.control.setValue(trimmedValue);
            }
        }
    }
}
